module.exports = "/_next/static/chromiums/og-1200x630-people-de9e3f0daf1b6a5a0ec4e4b7ccc0c74c.jpg";